<template>
  <Authenticated>
    <div class="menu-container">
      <!-- <section class="section">
        <h2>Add menu</h2>
        <p>Accepted file types jpeg/jpg, png, pdf, docx, doc</p>
        <form action="">
          <input type="file" @change="handleFile" accept="image/*, .jpeg, .jpg, .png,  application/*, .pdf, .docx, .doc" />
          <button class="action" @click.stop.prevent="uploadFile">Upload</button>
        </form>
      </section> -->
      <section class="section">
        <h2>Active site Menus</h2>
        <div v-for="site in siteMap" :key="site" class="site-menus">
          <RouterLink :to="`/menus/${site.site}`" class="site-btn" tabindex="0">{{ site.site }}</RouterLink>
        </div>
      </section>
    </div>
  </Authenticated>
</template>

<script>
import Authenticated from "../_layouts/Authenticated";
import { mapGetters } from "vuex";
export default {
  name: "Menus",
  components: { Authenticated },
  data() {
    return {
      file: null,
      erros: null,
    };
  },
  computed: {
    ...mapGetters({
      siteMap: "siteMap",
    }),
  },

  methods: {
    handleFile() {},
    uploadFile() {},
  },
};
</script>

<style scoped>
.none {
  display: none;
}

.header {
  margin: 3rem;
}

.site-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20rem;
  height: 2.5rem;
  margin: 0.5rem;
  padding: 1rem;
  background-color: var(--tertiary-colour);
  color: var(--text-colour);
  border-radius: 10px;
  box-shadow: var(--box-shadow);
  text-transform: capitalize;
  transition: color 0.3s ease-in-out;
  &:active {
    box-shadow: none;
  }
  &:hover {
    cursor: pointer;
    color: var(--action-colour);
  }
}

.menu-container {
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
  overflow: scroll;
  margin: 0 1rem;
  .section {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 50%;
    height: auto;
    border-radius: 10px;
    background-color: var(--primary-colour);
    box-shadow: var(--box-shadow);
    padding: 1rem;
    margin: 1rem;
    form {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      input {
        margin: 1rem;
        width: 20rem;
        height: 10rem;
        border: dotted 2px var(--action-colour);
        border-radius: 5px;
      }
      button {
        width: 20rem;
        margin: 1rem;
        background-color: var(--action-colour);
        color: var(--secondary-text-colour);
      }
    }

    .site-menus {
      a {
        background-color: var(--action-colour);
        color: var(--secondary-text-colour);
      }
    }
  }
}

@media only screen and (orientation: portrait) {
  .menu-container {
    flex-direction: column;
    padding: 0.5rem;
    .section {
      width: 90%;
      margin: 0.15rem;
      .site-btn {
        width: 15rem;
      }
      form {
        input {
          width: 15rem;
          height: 10rem;
        }
        button {
          width: 15rem;
        }
      }
    }
  }
}
</style>
